const Resources = {
  table_headers: [
    // {
    //     name: 'Select'
    // },
    {
      name: "#",
    },
    {
      name: "#Room",
    },
    {
      name: "Description",
    },
    {
      name: "Task",
    },
    {
      name: "Daily Min",
    },
    {
      name: "Annual Min",
    },
    {
      name: "Frequency",
    },
    {
      name: "SQ ft",
    },
    {
      name: "Group",
    },
  ],

  breadcrumb: [
    {
      name: "Home",
      href: "/",
      arrow: "<span class='slash'>/</span>",
    },
    {
      name: "Daily Assignments",
      href: `/assignment-daily-assignments`,
      arrow: "<span class='slash'>/</span>",
    },
    // {
    //     name:   'Associate - Assignment Time Details',
    //     href:   `/assignment-daily-assignments-associate-time-details`,
    //     arrow:  "",
    // },
  ],

  time_detail_options: [
    {
      id: 1,
      name: "Associate",
    },
    {
      id: 2,
      name: "Supervisor",
    },
    {
      id: 3,
      name: "Abbreviated",
    },
  ],

  class_shift_options: [
    { id: 1, name: "Day" },
    { id: 2, name: "Evening" },
    { id: 3, name: "Night" },
  ],
};

export default Resources;
